import { useRouter } from 'next/router'

import { CustomSelect } from '@wartek-id/select'

import { DEFAULT_PREDIKAT_FILTER } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'
import { PREDIKAT_LABELS } from 'app/KinerjaShared/components/PenetapanPredikatTable/constants'
import { usePenetapanPredikatTableStore } from 'app/KinerjaShared/components/PenetapanPredikatTable/Provider'

import type { PredikatFilterTypes } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

const PREDIKAT_FILTER_OPTIONS: Array<{
  value: PredikatFilterTypes
  name: string
}> = [
  { value: 'ALL', name: 'Semua Predikat Kinerja' },
  ...Object.entries(PREDIKAT_LABELS).map((label) => ({
    value: label[0] as PredikatFilterTypes,
    name: label[1] as string,
  })),
]

type PredikatFilterProps = {
  paramKey: string
}
export function PredikatFilter({ paramKey }: PredikatFilterProps) {
  const router = useRouter()
  const { predikatFilter, setPredikatFilter } = usePenetapanPredikatTableStore(
    (store) => ({
      predikatFilter: store.predikatFilter,
      setPredikatFilter: store.setPredikatFilter,
    })
  )

  const selected = PREDIKAT_FILTER_OPTIONS.find(
    (option) => option['value'] === predikatFilter
  )

  // Handle filter changes
  const handleFilterChange = (value: PredikatFilterTypes) => {
    // Update store
    setPredikatFilter(value)

    // Update URL
    const query = {
      ...router.query,
    }

    if (value !== DEFAULT_PREDIKAT_FILTER) {
      query[paramKey] = value
    } else {
      delete query[paramKey]
    }

    router.replace(
      {
        pathname: router.pathname,
        query,
      },
      undefined,
      { shallow: true }
    )
  }

  return (
    <CustomSelect
      className="w-64 text-nowrap"
      value={selected}
      options={PREDIKAT_FILTER_OPTIONS}
      onChange={(selectedOption) =>
        handleFilterChange(selectedOption['value'] as PredikatFilterTypes)
      }
    />
  )
}
